import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";
import { ApiKeyResponse } from "./post";

const APP_DELETE_APIKEY_API_VERSION = 0;

export const deleteApiKey = async (appId: string, deploymentId: string, apiKey: string) => {
    const url = `${API_URL}/saas/${appId}/deployment/apikey`;

    const result = await httpNetworking.simpleDELETERequest(
        url,
        { params: { deploymentId, apiKey } },
        APP_DELETE_APIKEY_API_VERSION
    );

    return result.data as ApiKeyResponse;
};
